module.exports = __webpack_public_path__ + "8406691444ff98ee33d4f6cc86cb0372.svg";